<template>
  <div>
    <div style="display: flex">
      <ol>
        <li>
          <router-link :to="{ name: 'Demo.List' }">
            <span>List</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Demo.Create' }">
            <span>Create</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Demo.Detail', params: { id: 334455 } }">
            <span>Detail</span>
          </router-link>
        </li>
      </ol>
    </div>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {}
</script>
